import '@/styles/globals.css'
import '@/styles/tiptap-variables.scss'
import '@/styles/keyframe-animations.scss'
import '@/components/tiptap/tiptap-templates/simple/simple-editor.scss'
import '@/components/tiptap/tiptap-node/blockquote-node/blockquote-node.scss'
import '@/components/tiptap/tiptap-node/code-block-node/code-block-node.scss'
import '@/components/tiptap/tiptap-node/horizontal-rule-node/horizontal-rule-node.scss'
import '@/components/tiptap/tiptap-node/list-node/list-node.scss'
import '@/components/tiptap/tiptap-node/image-node/image-node.scss'
import '@/components/tiptap/tiptap-node/heading-node/heading-node.scss'
import '@/components/tiptap/tiptap-node/paragraph-node/paragraph-node.scss'
import '@/components/tiptap/tiptap-ui/color-highlight-button/color-highlight-button.scss'
import '@/components/tiptap/tiptap-ui-primitive/badge/badge-colors.scss'
import '@/components/tiptap/tiptap-ui-primitive/badge/badge-group.scss'
import '@/components/tiptap/tiptap-ui-primitive/badge/badge.scss'
import '@/components/tiptap/tiptap-ui-primitive/button/button-colors.scss'
import '@/components/tiptap/tiptap-ui-primitive/button/button-group.scss'
import '@/components/tiptap/tiptap-ui-primitive/button/button.scss'
import '@/components/tiptap/tiptap-ui-primitive/card/card.scss'
import '@/components/tiptap/tiptap-ui-primitive/dropdown-menu/dropdown-menu.scss'
import '@/components/tiptap/tiptap-ui-primitive/input/input.scss'
import '@/components/tiptap/tiptap-ui-primitive/popover/popover.scss'
import '@/components/tiptap/tiptap-ui-primitive/separator/separator.scss'
import '@/components/tiptap/tiptap-ui-primitive/toolbar/toolbar.scss'
import '@/components/tiptap/tiptap-ui-primitive/tooltip/tooltip.scss'
import '@/components/tiptap/tiptap-node/fixed-title-node/fixed-title-node.scss'
import '@/components/tiptap/tiptap-node/placeholder-node/placeholder-node.scss'
import '@/components/tiptap/tiptap-node/small-node/small-node.scss'
import '@/components/tiptap/tiptap-ui/typography-button/typography-button.scss'

import { datadogRum } from '@datadog/browser-rum'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { AppProps } from 'next/app'
import { Session } from 'next-auth'
import { SessionProvider } from 'next-auth/react'
import React from 'react'

const isProduction =
  process.env.NODE_ENV === 'production' &&
  process.env.VERCEL_ENV === 'production'

if (isProduction) {
  datadogRum.init({
    applicationId: `${process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID}`,
    clientToken: `${process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN}`,
    site: 'datadoghq.com',
    service: 'nopk-customer-agreements-tool-front-end',
    env: `${process.env.NODE_ENV}`,
    version: '1.0.0',
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  })

  datadogRum.startSessionReplayRecording()
}

const App = ({
  Component,
  pageProps,
}: AppProps<{
  session: Session
}>) => {
  const [queryClient] = React.useState(() => new QueryClient())
  return (
    <SessionProvider session={pageProps.session} refetchInterval={0}>
      <QueryClientProvider client={queryClient}>
        <Component {...pageProps} />
      </QueryClientProvider>
    </SessionProvider>
  )
}

export default App
